import {Injectable} from '@angular/core';
import {TenantService} from './tenant.service';
import {Course} from '../models/course.model';
import {Lesson} from '../models/lesson.model';
import {environment} from '../../environments/environment';
import {ProtectedResourceAccess} from '../models/protected-resource-access.model';
import {SupportedLanguage} from '../models/supported-language.model';

@Injectable({
  providedIn: 'root'
})
export class UrlBuilderService {

  constructor(private tenant: TenantService) {

  }


  getFlagUrl(language: SupportedLanguage) {
    if (environment.production) {
      return `https://${environment.platformCloudfrontDomain}/images/min-img/ISO/${language}.png`;
    }
    else {
      return `/assets/images/min-img/ISO/${language}.png`;
    }
  }

  buildImageUrl(imagePath:string) {

    let path:string;

    if (!imagePath.startsWith("/")) {
      path = `/${imagePath}`;
    }
    else {
      path = imagePath;
    }

    if (environment.production || environment.test) {
      return `https://${environment.platformCloudfrontDomain}/assets${path}`;
    }
    else {
      return `/assets${path}`;
    }
  }

  buildCourseThumbnailUrl(course: Course) {
    if (course && course.thumbnail) {
      return `https://firebasestorage.googleapis.com/v0/b/${environment.firebase.storageBucket}/o/${this.tenant.id}%2F${course.id}%2Fthumbnail%2F${course.thumbnail}?alt=media`;
    }
    else {
      return null;
    }
  }



  buildLessonThumbailUrl(course: Course, lesson:Lesson) {
    if (course && lesson && lesson.thumbnail) {
      return `https://firebasestorage.googleapis.com/v0/b/${environment.firebase.storageBucket}/o/${this.tenant.id}%2F${course.id}%2FprotectedResources%2F${lesson.id}%2F${lesson.thumbnail}?alt=media`;
    }
    else {
      return null;
    }
  }

  buildLessonResourceUrl(course: Course, lesson:Lesson, access: ProtectedResourceAccess) {
    if (course && lesson && lesson.originalFileName) {
      return `https://firebasestorage.googleapis.com/v0/b/${environment.firebase.storageBucket}/o/${this.tenant.id}%2F${course.id}%2FprotectedResources%2F${lesson.id}%2F${access.secretResourceName}?alt=media`;
    }
    else {
      return null;
    }
  }

}
